import axios from 'axios';
import Bindings from '../bindings';
import { type Deps, VisionEnv } from './updater';

class UnknownVisionEnvironmentError extends Error {}

export const deps: Deps = {
  pathJoin: async (pathA, pathB) => {
    const { path } = await Bindings.fs.pathJoin(pathA, pathB);
    return path;
  },
  ensureDirs: (dirs) => {
    return Promise.all(
      dirs.map(async (dir) => {
        const { success } = await Bindings.fs.mkdir(dir);
        if (!success) {
          return Promise.reject();
        }
      }),
    );
  },
  readFileToString: async (path) => {
    const f = await Bindings.fs.readFile(path);
    return f.contents;
  },
  parseJSON: <T = unknown>(jsonStr: string): T => {
    return JSON.parse(jsonStr) as T;
  },
  fetchJSON: async <T = unknown>(url: URL): Promise<T> => {
    const r = await axios.get<T>(url.toString());
    return r.data;
  },
  getVisionEnv: async () => {
    try {
      const r = await Bindings.sys.getEnvVar('VISION_ENV');
      const env = r.value;
      // TODO: is there a meta way to do this enum check?
      if (
        !(
          [VisionEnv.Production, VisionEnv.Staging, VisionEnv.Local] as string[]
        ).includes(env)
      ) {
        throw new UnknownVisionEnvironmentError();
      }

      return env as VisionEnv;
    } catch {
      return VisionEnv.Production;
    }
  },
  getCacheBusterString: (): string => {
    return Math.floor(Date.now() / 1000).toString();
  },
  spawnProcess: async (path, hidden = false) => {
    console.debug('Spawning process', path, 'hidden:', hidden);
    const { pid } = await Bindings.fs.runExe(path, hidden);

    if (!pid) {
      return Promise.reject();
    }

    return pid;
  },
  terminateProcess: async (pid) => {
    const { success } = await Bindings.sys.stopProcess(pid);
    if (!success) {
      return Promise.reject();
    }
  },
};
